import React from 'react';
import {
    Typography,
    Box,
    Paper
} from '@mui/material';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        [theme.breakpoints.only('xs')]: {
            flexDirection: 'column'
        },
    }, headerWidth: {
        width: '80%',
        [theme.breakpoints.only('xs')]: {
            width: '100%',
        },
    },
    count: {
        marginLeft: 30,
        fontSize: '14px',
        fontWeight: 900,
        marginRight: 10
    },
    flex: {
        [theme.breakpoints.only('xs')]: {
            flex: 2
        },
    },
    paper: {
        padding: '1px',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        borderRadius: '5px',
        marginRight: 'auto',
        backgroundColor: '#E4EDFF',
        margin: '8px 0px 0px 0px',
        [theme.breakpoints.only('xs')]: {
            padding: '6px',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
    }
}));

const AllotedUsedCount = (props) => {
    const classes = useStyles();
    return (
        <>
            <Box>
                <Paper
                    elevation={3}
                    className={classes.paper}>
                    <Box className={classes.container}>
                        <Box className={classes.headerWidth}>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    lineHeight: '23.44px',
                                    color: '#1D428A',
                                }}>
                                {props.moduleName} :
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'row',
                                //justifyContent: 'space-between',
                                m: '5px',
                                width: '100%',
                            }}>
                            <Box className={classes.flex}>
                                <Typography component={'span'}
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: '15px',
                                        color: '#000000',
                                        lineHeight: '25px',
                                    }}>
                                    Used :
                                </Typography>
                            </Box>
                            <Box>
                                <Typography component={'span'}>
                                    <span className={classes.count}>
                                        {' '}
                                        {props.eventConfig.used}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'row',
                                //justifyContent: 'space-between',
                                width: '100%',
                            }}>
                            <Box className={classes.flex}>
                                <Typography component={'span'}
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: '15px',
                                        color: '#000000',
                                        lineHeight: '25px',
                                    }}>
                                    Allotted :
                                </Typography>
                            </Box>
                            <Box >
                                <Typography component={'span'}>

                                    <span className={classes.count}>
                                        {props.eventConfig.allotted}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>

                    </Box>
                </Paper>
            </Box>

        </>
    )
}

export default AllotedUsedCount;